var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookmarkCount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.77935 13.9187C3.4471 14.1405 3.00171 13.9024 3.00171 13.5029V4.01167C3.00171 2.9085 3.89496 2.01365 4.99813 2.01168L10.9981 2.00092C12.1027 1.99895 12.9997 2.89277 13.0017 3.99734V13.5029C13.0017 13.9024 12.5563 14.1405 12.2241 13.9187L8.00171 11.0994L3.77935 13.9187ZM12.0017 4.00092L11.9948 3.88252C11.9361 3.38529 11.5128 3.00001 10.9999 3.00092L4.99992 3.01168C4.44833 3.01266 4.00171 3.46009 4.00171 4.01167V12.5678L7.72406 10.0824C7.89215 9.97018 8.11127 9.97018 8.27936 10.0824L12.0017 12.5678V4.00092Z",
    fill: "#616161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkCount);
export default __webpack_public_path__ + "static/media/bookmarkCount.3adad24e58bb7227ac9c60e2ff2fa134.svg";
export { ForwardRef as ReactComponent };